package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** Portal questions; also used for the FAQPage structured data. */
val PortalFaqs = listOf(
    RdText.PORTAL_FAQ1_Q to RdText.PORTAL_FAQ1_A,
    RdText.PORTAL_FAQ2_Q to RdText.PORTAL_FAQ2_A,
    RdText.PORTAL_FAQ3_Q to RdText.PORTAL_FAQ3_A,
    RdText.PORTAL_FAQ4_Q to RdText.PORTAL_FAQ4_A,
    RdText.PORTAL_FAQ5_Q to RdText.PORTAL_FAQ5_A,
)

@Composable
fun PortalFaqSection() {
    RdFaqBand(RdText.PORTAL_FAQ_TITLE, PortalFaqs)
}
